import {Component, input} from "@angular/core";
import {SimStatusPalette} from "../../models/SimStatusPalette";
import {Translations} from "../../../../sim.translations.barrel";
import {EventState} from "@models";

@Component({
	selector: "sim-event-status-tag",
	templateUrl: "./event-status-tag.component.html",
	styleUrl: "./event-status-tag.component.scss",
	standalone: false,
})
export class EventStatusTagComponent {
	public eventState = input.required<EventState>();
	public border = input<boolean>(false);

	protected readonly SimStatusPalette = SimStatusPalette;
	protected readonly T = Translations;
	protected readonly EventState = EventState;
}
